import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import RemoveScheduledPaymentModal from './RemoveScheduledPaymentModal';
import moment from 'moment';
import numeral from 'numeral';

const ScheduledPayment = ({scheduledPayment, onDelete, actions }) => {
    const [deleteOpen, setDeleteOpen] = useState(false);

    const _onDelete = useCallback(() => {
		setDeleteOpen(false);
		onDelete();
    }, [onDelete])
    

	return (
		<Table.Row>
			<Table.Cell>{scheduledPayment.accountBillNumber || scheduledPayment.policyNumber}</Table.Cell>
			<Table.Cell>{moment(scheduledPayment.paymentScheduleDate).format('L')}</Table.Cell>
			<Table.Cell>{numeral(scheduledPayment.paymentAmount).format('$ 0,0.00')}</Table.Cell>
			<Table.Cell>
                <RemoveScheduledPaymentModal 
                    open={deleteOpen}
                    onOpen={() => setDeleteOpen(true)} 
                    onClose={() => setDeleteOpen(false)} 
                    onDelete={_onDelete} 
                    scheduledPayment={scheduledPayment}
					actions={actions} />
			</Table.Cell>
		</Table.Row>
	);
};

ScheduledPayment.propTypes = {
    scheduledPayment: PropTypes.object.isRequired
};

export default ScheduledPayment;
